import { Component, Input, OnInit, inject } from "@angular/core";
import { Roster } from "@app/models/rest/roster/roster";
import { BaseDataTablePageDirective } from "@app/view/shared/base-pages/base-data-table-page/base-data-table-page.directive";
import { RosterRunHistoryStore } from "@app/services/store/roster/roster-run-history-store";
import { SystemSearchMetaRestService } from "@app/services/hal/system-search-meta-rest.service";
import { Store } from "@ngrx/store";
import { MatDialog } from "@angular/material/dialog";
import { UntypedFormBuilder } from "@angular/forms";
import { Router } from "@angular/router";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { RunHistoryDialogComponent } from "@app/view/setup/resourcing/roster/run-history-dialog/run-history-dialog.component";
import { RosterService } from "@app/services/http/roster.service";
import moment from "moment";
import { ServiceErrorHandlerService } from "@app/view/shared/service-error-handler.service";
import { RosterRunDialogComponent } from "@app/view/setup/resourcing/roster/roster-run-dialog/roster-run-dialog.component";
import { RosterRunHistory } from "@app/models/rest/roster/roster-run-history";
import { MatToolbar } from "@angular/material/toolbar";
import { MatButton } from "@angular/material/button";
import { GridComponent } from "@app/view/shared/base-pages/base-data-table-page/grid.component";
import { MatPaginator } from "@angular/material/paginator";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "app-run-history-view-grid",
  templateUrl: "./run-history-view-grid.component.html",
  styleUrls: ["./run-history-view-grid.component.css"],
  imports: [MatToolbar, MatButton, GridComponent, MatPaginator, TranslatePipe]
})
export class RunHistoryViewGridComponent
  extends BaseDataTablePageDirective<RosterRunHistory>
  implements OnInit
{
  rosterRunHistoryStore: RosterRunHistoryStore;
  protected store: Store<any>;
  protected dialog: MatDialog;
  protected formBuilder: UntypedFormBuilder;
  protected router = inject(Router);
  protected rosterService = inject(RosterService);
  serverErrorHandler: ServiceErrorHandlerService;
  protected ngxUiLoaderService: NgxUiLoaderService;

  @Input()
  public roster: Roster;
  @Input()
  public columns: object[] = [
    {
      field: "runTime",
      text: "Run Date",
      flex: 1,
      format: "DD/MM/YYYY HH:mm",
      type: "date",
      editor: false
    },
    {
      text: "Time Ago",
      flex: 1,
      type: "template",
      template: ({ record }) => moment(record.runTime).fromNow(),
      editor: false
    },
    {
      text: "Shifts Generated",
      flex: 1,
      type: "number",
      field: "generatedShiftCount",
      editor: false
    },
    {
      type: "action",
      text: "View",
      width: 50,
      actions: [
        {
          cls: "b-fa b-fa-history",
          tooltip: "View",
          onClick: ({ record }) => {
            console.log(`Viewing ${record.name}`);
            console.log(this.router);
            // this.router.navigate(['setup/resourcing/rosters', record.id]).then();
            console.log("loading ", record);
            let dialogRef = this.dialog.open(RunHistoryDialogComponent, {
              width: "700px",
              data: {
                runHistory: record
              }
            });
          }
        }
      ]
    }
  ];

  constructor() {
    const systemSearchMetaRestService = inject(SystemSearchMetaRestService);
    const rosterRunHistoryStore = inject(RosterRunHistoryStore);
    const store = inject<Store<any>>(Store);
    const dialog = inject(MatDialog);
    const formBuilder = inject(UntypedFormBuilder);
    const serverErrorHandler = inject(ServiceErrorHandlerService);
    const ngxUiLoaderService = inject(NgxUiLoaderService);

    super(
      systemSearchMetaRestService,
      rosterRunHistoryStore,
      store,
      dialog,
      "RosterRunHistory",
      formBuilder,
      serverErrorHandler,
      ngxUiLoaderService
    );

    this.rosterRunHistoryStore = rosterRunHistoryStore;
    this.store = store;
    this.dialog = dialog;
    this.formBuilder = formBuilder;
    this.serverErrorHandler = serverErrorHandler;
    this.ngxUiLoaderService = ngxUiLoaderService;
  }

  public get pristine() {
    return (
      !this.gridStore.changes ||
      (this.gridStore.changes.added.length === 0 &&
        this.gridStore.changes.removed.length === 0 &&
        this.gridStore.changes.modified.length === 0)
    );
  }

  ngOnInit() {
    super.ngOnInit();
    if (!this.roster) {
      return;
    }
    this.gridStore.parentField = "roster.id";
    this.gridStore.parentId = this.roster.id;
    this.gridStore.parentResource = this.roster;
    this.gridStore.parentRel = "roster";
    this.gridStore.autoCommit = false;
    this.gridStore.sort("runTime", false);
    this.gridStore.load({});
  }

  addRow() {
    this.gridStore.insert(0, {
      code: "",
      description: "",
      scoreWeight: 1
    });
  }

  runNow() {
    let dialog = this.dialog.open(RosterRunDialogComponent);
    dialog.afterClosed().subscribe((result) => {
      if (result.confirmed) {
        this.rosterService.generateRoster(this.roster.id).then((value) => {
          console.log("roster ran");
          this.gridStore.load({});
        });
      }
    });
  }
}
